/* eslint-disable no-script-url */
import React from 'react';
import A from '../../../common/A';

import { MenuButton } from '../../../navigate';

const LoginTypeHeader = ({ title, isMenuBtn }) => (
  <div className="inner">
    <div className="btns_wrap header-trans">
      <div className="login cls">
        <A>{title}</A>
      </div>
      {
        isMenuBtn && (
          <div className="right_area">
            <div className="menu_btn">
              <MenuButton />
            </div>
          </div>
        )
      }
    </div>
  </div>
)

const JoinTypeHeader = ({ title, isMenuBtn }) => (
  <div className="btns_wrap">
    <div className="center_wrap cls">
      <div className="tit_area">
        <button className="tit_btn" type="button">회원가입</button>
      </div>
      {
        isMenuBtn && (
          <div className="right_area">
            <div className="menu_btn">
              <MenuButton
                iconPath="static/images/icon/ic_menu_32@2x.png"
              />
            </div>
          </div>
        )
      }
    </div>
  </div>
)

function Header({ title, isMenuBtn, type="login" }) {

  return (
    <div className="header_top">
      {(() => {
        switch (type) {
          case "login":
            return <LoginTypeHeader title={title} isMenuBtn={isMenuBtn} />
          case "join":
            return <JoinTypeHeader title={title} isMenuBtn={isMenuBtn} />
          default:
            break;
        }
      })()}
    </div>
  );
}

export default Header;